import jump from "jump.js";

export default () => {
  // ページTopへボタン
  const topbtns = document.querySelectorAll(".js-toTop");
  topbtns.forEach((topbtn) => {
    topbtn.addEventListener("click", (event) => {
      event.preventDefault();
      jump("html", {
        duration: 500,
        offset: 0,
      });
    });
  });

  // PC Topへボタンの表示
  const site = document.querySelector(".site");
  const btn = document.querySelector(".to-top-pc");
  const options = {
    root: null,
    rootMargin: "50% 0px -150% 0px",
    threshold: 0,
  };
  const doWhenoutwrap = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        btn.dataset.showState = true;
      } else {
        btn.dataset.showState = false;
      }
    });
  };
  const observer = new IntersectionObserver(doWhenoutwrap, options);
  observer.observe(site);
};
